import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class DropzoneService {
  private mapFiles: Map<string, File[]> = new Map<string, any[]>();
  setFiles(identifier: string, files: any[]) {
    this.mapFiles.set(identifier, files);
  }
  getFiles(identifier: string): File[] {
    return this.mapFiles.get(identifier) || [];
  }
  removeFile(identifier: string, file: File) {
    const files = this.mapFiles.get(identifier);
    const index = files?.findIndex((f) => f.name);
    if (index !== -1) files?.splice(index!, 1);
  }
  clearFiles() {
    this.mapFiles.clear();
  }
}
